// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1RQWF","infoBtn":"quickbooks_infoBtn__3zJDp","formBox":"quickbooks_formBox__2Xf1v","formFooter":"quickbooks_formFooter__klP2E"};